/**
 * @module Experince/Product-Selector
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const PRODUCT_SELECTOR_MODEL_CONSTANTS = {
  NEW: 'new',
};
